import { useMemo } from 'react'
import sum from 'lodash/sum'

import { createColumns } from './columnGroupCreator'

import { MoySkladProductPricesCell } from '../components/tableCells/MoySkladProductPricesCell'
import { MoySkladProductSyncLogsCell } from '../components/tableCells/MoySkladProductSyncLogsCell'

import { msProductTypeNames } from '../store/logic/productUtils'

import { formatBalance, formatPriceOrEmpty } from '../common/numberUtils'

import { tableCellStyles } from '../hooks/tableStylesHook'

import { TableColumn } from './tableTypes'
import { MoySkladProductModel } from '../server/mpsklad_core/Models/MoySkladProductModel'

export type MoySkladProductColumnId =
  keyof Pick<MoySkladProductModel,
    'moySkladId' | 'type' | 'code' | 'article' | 'name' | 'barcodes' | 'price' | 'basePrice' | 'prices' | 'balance'>
  | 'logs'
  | 'balanceTotal'
  | 'cardPublicationStatus' | 'apiMessage' | 'lastSyncDate'

export type MoySkladProductColumn =
  TableColumn<MoySkladProductColumnId, MoySkladProductModel>

export const useMoySkladProductColumns =
  (): MoySkladProductColumn[] =>
    useMemo((): MoySkladProductColumn[] =>
        createColumns<MoySkladProductColumnId, MoySkladProductModel>({
          id: 'moySkladId',
          title: 'GUID'
        }, {
          id: 'type',
          title: 'Тип',
          accessor: _ => msProductTypeNames[_.type]
        }, {
          id: 'code',
          title: 'Код'
        }, {
          id: 'article',
          title: 'Артикул'
        }, {
          id: 'name',
          title: 'Наименование'
        }, {
          id: 'barcodes',
          title: 'Штрихкоды',
          cellStyle: tableCellStyles.noWrap
        }, {
          id: 'price',
          title: 'Цена',
          accessor: _ => formatPriceOrEmpty(_.price),
          cellStyle: tableCellStyles.noWrap
        }, {
          id: 'basePrice',
          title: 'Цена без скидки',
          accessor: _ => formatPriceOrEmpty(_.basePrice),
          cellStyle: tableCellStyles.noWrap
        }, {
          id: 'prices',
          title: 'Цены',
          CellComponent: MoySkladProductPricesCell
        }, {
          id: 'balance',
          title: 'Остатки на сматченных складах',
          accessor: row => row.balance.map(_ => `${_.storeName}: ${formatBalance(_.balance)}`)
        }, {
          id: 'balanceTotal',
          title: 'Общий остаток',
          titleHint: 'Для сматченных складов',
          accessor: row => formatBalance(sum(row.balance.map(_ => _.balance)))
        }, {
          id: 'logs',
          title: 'Логи',
          CellComponent: MoySkladProductSyncLogsCell
        }) satisfies MoySkladProductColumn[],
      [])